<!-- 绑定收货地址 -->
<template>
  <popup-frame ref="address" @close="$emit('close')">
    <form
      autocomplete="off"
      @submit.prevent="handleSubmit"
      :class="$style.form"
    >
      <!-- 收货人姓名 -->
      <div :class="$style.field">
        <input
          v-model="name"
          :maxlength="10"
          :readonly="isLocked"
          placeholder="请输入收货人姓名"
          :class="$style['field-input']"
        />
      </div>
      <!-- 收货人手机号码 -->
      <div :class="$style.field">
        <input
          v-model="phone"
          type="tel"
          maxlength="11"
          :readonly="isLocked"
          placeholder="请输入收货人手机号码"
          :class="$style['field-input']"
        />
      </div>
      <!-- 收货人地址 -->
      <div :class="$style.field">
        <input
          v-model="address"
          :maxlength="100"
          :readonly="isLocked"
          placeholder="请输入收货人地址"
          :class="$style['field-input']"
        />
      </div>
      <button v-if="!isLocked" :class="$style['btn-submit']" />
      <p style="font-size: .19rem;">
        注:确认后如果需要更改请在【道友请留步】官方微信公众号联系人工客服
      </p>
    </form>
  </popup-frame>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { PopupFrame } from "@/components/widgets";
import { bindAddress } from "@/api";

export default {
  name: "TheBindAddress",
  components: { PopupFrame },
  props: {
    prizeName: String
  },
  data() {
    return {
      /** 是否锁定表单, 锁定后无法提交数据 */
      isLocked: false,
      /** 联系人 */
      name: null,
      /** 联系电话 */
      phone: null,
      /** 联系地址 */
      address: null
    };
  },
  computed: {
    ...mapGetters(["addressData"])
  },
  mounted() {
    if (Object.keys(this.addressData).length) {
      this.handleInit(this.addressData);
    }
  },
  watch: {
    addressData: {
      handler: function() {
        if (Object.keys(this.addressData).length) {
          this.handleInit(this.addressData);
        } else {
          this.handleInit();
        }
      }
    }
  },
  methods: {
    ...mapActions(["setAddressData"]),
    async handleInit(data) {
      if (data) {
        const { address, name, tel } = data;
        this.isLocked = true;
        this.name = name;
        this.phone = tel;
        this.address = address;
      } else {
        this.isLocked = false;
        this.name = "";
        this.phone = "";
        this.address = "";
      }
    },
    async handleSubmit() {
      if (!this.verifyData()) {
        const data = {
          tel: this.phone,
          name: this.name,
          address: this.address
        };
        const { code, msg } = await bindAddress(data);
        if (code === 0) {
          this.$toast(msg);
          this.isLocked = true;
          this.setAddressData(data);
        }
      }
    },
    verifyData() {
      if (!this.name) {
        return this.$toast("请输入收货人姓名");
      } else if (!this.phone) {
        return this.$toast("请输入收货人手机号码");
      } else if (!/^1\d{10}$/.test(this.phone)) {
        return this.$toast("请输入有效的收货人手机号码");
      } else if (!this.address) {
        return this.$toast("请输入收货人地址");
      }
      return false;
    },
    show() {
      this.$refs.address.show();
    }
  }
};
</script>

<style lang="less" module>
@input-width: 6.5rem;
@input-height: 0.7rem;

.form {
  .size(@input-width, 100%);

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 0.25rem;
  margin: 0 auto;

  // 标题
  &::before {
    .size(6rem, 0.35rem);
    .background-fill("./images/bind-address-title.png");

    content: "";
    display: block;
    margin: 0 auto;
  }
}

/* 输入项 */
.field {
  .size(100%, @input-height);

  position: relative;

  &-input {
    .size(100%);

    padding-left: 0.75em;
    border: 0.02rem solid #d3b783;
    background-color: transparent;
    font-size: 0.3rem;

    &::placeholder {
      color: inherit;
      opacity: 0.6;
    }
  }
}

/* 表单提交按钮 */
.btn-submit {
  .size(1.59rem, 0.57rem);
  .background-fill("./images/bind-address-submit.png");

  &[disabled] {
    opacity: 0.5;
    cursor: default;
  }
}
</style>
